import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    },

    methods: {
        close() {
            this.$emit('close', true);
        },
    },
};
